import { Row, Col, Typography, Space } from "antd";
import { useTranslation } from "react-i18next";
import {
  PhoneOutlined,
  MailOutlined,
  EnvironmentOutlined,
  FacebookOutlined,
  InstagramOutlined,
} from "@ant-design/icons";
import YandexMap from "../components/YandexMap";
import {
  HeroSection,
  HeroContainer,
  HeroTitle,
  HeroSubtitle,
  ContactSection,
  ContactContainer,
  ContactCard,
  GallerySection,
  GalleryContainer,
  GalleryTitle,
  GalleryGrid,
  GalleryItem,
  GalleryImage,
  SocialSection,
  SocialContainer,
  SocialLinks,
  SocialLink,
  MapSection,
  MapContainer,
  MapTitle,
  MapWrapper,
  MapAddress,
  WorkingHoursRow,
} from "./LandingPage.styled";

import image1 from "../assets/1.jpg";
import image2 from "../assets/2.jpg";
import image3 from "../assets/3.jpg";
import image4 from "../assets/4.jpg";
import image5 from "../assets/5.jpg";
import image6 from "../assets/6.jpg";

const { Text } = Typography;

const LandingPage: React.FC = () => {
  const { t } = useTranslation();

  const workingHours = [
    { day: t("contact.monday"), hours: "10:00 - 22:00" },
    { day: t("contact.tuesday"), hours: "10:00 - 22:00" },
    { day: t("contact.wednesday"), hours: "10:00 - 22:00" },
    { day: t("contact.thursday"), hours: "10:00 - 22:00" },
    { day: t("contact.friday"), hours: "10:00 - 23:00" },
    { day: t("contact.saturday"), hours: "11:00 - 23:00" },
    { day: t("contact.sunday"), hours: "11:00 - 23:00" },
  ];

  // Mock gallery data - replace with real images
  const galleryImages = [
    {
      id: 1,
      src: image1,
    },
    {
      id: 2,
      src: image2,
    },
    {
      id: 3,
      src: image3,
    },
    {
      id: 4,
      src: image4,
    },
    {
      id: 5,
      src: image5,
    },
    {
      id: 6,
      src: image6,
    },
  ];

  return (
    <div>
      {/* Hero Section */}
      <HeroSection>
        <HeroContainer>
          <HeroTitle level={1}>{t("hero.title")}</HeroTitle>
          <HeroSubtitle>{t("hero.subtitle")}</HeroSubtitle>
        </HeroContainer>
      </HeroSection>

      {/* Contact Section */}
      <ContactSection>
        <ContactContainer>
          <Row gutter={[24, 24]}>
            <Col xs={24} md={8}>
              <ContactCard title={t("contact.booking")}>
                <Space
                  direction="vertical"
                  size="middle"
                  style={{ width: "100%" }}
                >
                  <div>
                    <PhoneOutlined
                      style={{ marginRight: 8, color: "#1890ff" }}
                    />
                    <Text strong>+374 77 78 88 82</Text>
                  </div>
                  <div>
                    <MailOutlined
                      style={{ marginRight: 8, color: "#1890ff" }}
                    />
                    <Text>oshakankghzi@gmail.com</Text>
                  </div>
                </Space>
              </ContactCard>
            </Col>

            <Col xs={24} md={8}>
              <ContactCard title={t("contact.delivery")}>
                <Space
                  direction="vertical"
                  size="middle"
                  style={{ width: "100%" }}
                >
                  <div>
                    <PhoneOutlined
                      style={{ marginRight: 8, color: "#1890ff" }}
                    />
                    <Text strong>+374 95 39 90 93</Text>
                  </div>
                  <div>
                    <MailOutlined
                      style={{ marginRight: 8, color: "#1890ff" }}
                    />
                    <Text>oshakankghzi@gmail.com</Text>
                  </div>
                </Space>
              </ContactCard>
            </Col>

            <Col xs={24} md={8}>
              <ContactCard title={t("contact.workingHours")}>
                <Space
                  direction="vertical"
                  size="small"
                  style={{ width: "100%" }}
                >
                  {workingHours.map((item, index) => (
                    <WorkingHoursRow key={index}>
                      <Text>{item.day}</Text>
                      <Text>{item.hours}</Text>
                    </WorkingHoursRow>
                  ))}
                </Space>
              </ContactCard>
            </Col>
          </Row>
        </ContactContainer>
      </ContactSection>

      {/* Photo Gallery Section */}
      <GallerySection>
        <GalleryContainer>
          <GalleryTitle level={2}>{t("gallery.title")}</GalleryTitle>
          <GalleryGrid>
            {galleryImages.map((image) => (
              <GalleryItem key={image.id}>
                <GalleryImage src={image.src} alt="Gallery Image" />
              </GalleryItem>
            ))}
          </GalleryGrid>
        </GalleryContainer>
      </GallerySection>

      {/* Social Media Section */}
      <SocialSection>
        <SocialContainer>
          <Typography.Title level={2}>{t("social.followUs")}</Typography.Title>
          <SocialLinks>
            <SocialLink
              href="https://www.facebook.com/oshakan.kghzi"
              target="_blank"
              rel="noopener noreferrer"
              className="facebook"
            >
              <FacebookOutlined />
              {t("social.facebook")}
            </SocialLink>
            <SocialLink
              href="https://www.instagram.com/oshakan.kghzi"
              target="_blank"
              rel="noopener noreferrer"
              className="instagram"
            >
              <InstagramOutlined />
              {t("social.instagram")}
            </SocialLink>
          </SocialLinks>
        </SocialContainer>
      </SocialSection>

      {/* Map Section */}
      <MapSection>
        <MapContainer>
          <MapTitle level={2}>{t("map.title")}</MapTitle>
          <MapWrapper>
            <YandexMap />
          </MapWrapper>
          <MapAddress>
            <EnvironmentOutlined style={{ marginRight: 8, color: "#1890ff" }} />
            <Text>{t("map.address")}</Text>
          </MapAddress>
        </MapContainer>
      </MapSection>
    </div>
  );
};

export default LandingPage;
